import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { DialogLayoutComponent } from "@obg/mat.ui.core";
import {
	AuthSelector,
	Balance,
	CORE_ROUTE,
	LimitsModalType,
	LimitsReminderAction,
	LimitsReminderSelector,
	LimitsSummary,
	WalletSelector,
} from "@obg/ngx.core";
import { RouteAction, RouterState } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { merge, Observable, Subscription } from "rxjs";
import { filter, take, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-limits-reminder-container",
	templateUrl: "./limits-reminder-dialog.container.html",
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LimitsReminderDialogContainer implements OnInit, OnDestroy {
	@ViewChild("dialog") dialogLayoutComponent!: DialogLayoutComponent;

	limitsModalType$: Observable<LimitsModalType> | undefined;
	balance$: Observable<Balance> | undefined;
	limitsSummary$: Observable<LimitsSummary> | undefined;

	private isAuthenticated: boolean | undefined;

	private data$$: Subscription | undefined;

	constructor(
		private store: Store<RouterState>,
		private changeDetector: ChangeDetectorRef,
		private walletSelector: WalletSelector
	) {}

	ngOnInit() {
		this.limitsModalType$ = this.store.pipe(select(LimitsReminderSelector.getLimitsReminderType), ignoreNil());

		this.balance$ = this.store.pipe(select(this.walletSelector.getCurrentProductBalance()), ignoreNil(), take(1));

		this.limitsSummary$ = this.store.pipe(select(LimitsReminderSelector.getLimits), ignoreNil());

		const showLimitsReminder$ = this.store.pipe(
			select(AuthSelector.isAuthenticated),
			ignoreNil(),
			filter((isAuthenticated) => isAuthenticated),
			tap((isAuthenticated) => {
				this.isAuthenticated = isAuthenticated;
				this.store.dispatch(LimitsReminderAction.fetchLimitsSummary(false));
			})
		);

		this.data$$ = merge(showLimitsReminder$).subscribe(() => this.changeDetector.markForCheck());
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	closeDialog() {
		this.dialogLayoutComponent.close();

		if (!this.isAuthenticated) {
			this.store.dispatch(LimitsReminderAction.clear());
		}
	}

	redirectToResponsibleGaming() {
		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.responsibleGaming.information));

		this.closeDialog();
	}
}
